import { SheduleEditorFormValues } from 'types/state';

export const createSheduleEditorFormValues = (): SheduleEditorFormValues => ({
  restaurantShedule: '',
  huntingShedule: ''
});
